module.exports = "{{ name }}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/object-status/object-status.component.html
// module id = ./src/app/shared/object-status/object-status.component.html
// module chunks = main